import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SectorsComponent } from './sectors.component';
import { CardModule } from 'libraries/ui_card/card.module';
import { SectorsAirModule } from './components/sectors-air/sectors-air.module';
import { DateModule } from 'libraries/module/formbuilder/fields/date/date.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { DateDifferenceModule } from 'libraries/service/date/date-diffrence.module';
import { SectorsStayModule } from './components/sectors-stay/sectors-stay.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { MenuDetailsModule } from 'libraries/hotel/components/menu-details/menu-details.module';
import { MultiselectModule } from 'libraries/module/formbuilder/fields/multiselect/multiselect.module';
import { SectorModule } from 'libraries/service/sector/sector.module';
import { PermissionModule } from 'libraries/permission/permission.module';

@NgModule({
    declarations: [
        SectorsComponent,
    ],
    imports: [
        CommonModule,
        CardModule,
        SectorsAirModule,
        SectorsStayModule,
        DateModule,
        NotificationModule,
        BtnModule,
        DateDifferenceModule,
        MenuDetailsModule,
        MultiselectModule,
        ReactiveFormsModule,
        SectorModule,
        PermissionModule
    ],
    exports: [
        SectorsComponent,
    ]
})
export class SectorsModule {}